/* Shipping schedule for bb-357-slim-picks only. Warehouse closures are explicit Pacific dates. */
(function(root){
 'use strict';
 const zone='America/Los_Angeles';
 const parts=new Intl.DateTimeFormat('en-US',{timeZone:zone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
 function state(now,closedDates=[]){
  const p=Object.fromEntries(parts.formatToParts(new Date(now)).map(x=>[x.type,x.value]));
  const day=new Date(Date.UTC(+p.year,+p.month-1,+p.day));
  const key=d=>d.toISOString().slice(0,10);
  const open=d=>d.getUTCDay()>0&&d.getUTCDay()<6&&!closedDates.includes(key(d));
  const remaining=15*3600-(+p.hour*3600 + +p.minute*60 + +p.second);
  if(open(day)&&remaining>0)return {today:true,remaining,date:key(day)};
  let next=new Date(day); if(open(day)||remaining<=0)next.setUTCDate(next.getUTCDate()+1);
  while(!open(next))next.setUTCDate(next.getUTCDate()+1);
  return {today:false,remaining:0,date:key(next),label:new Intl.DateTimeFormat('en-US',{timeZone:'UTC',weekday:'long',month:'long',day:'numeric'}).format(next)};
 }
 if(typeof module==='object'&&module.exports){module.exports={state};return;}
 if(!document.querySelector('[data-bb-357][data-shipping-country]'))return;
 const configNode=document.getElementById('bb-shipping-schedule');
 if(!configNode)return;
 const config=JSON.parse(configNode.textContent);
 // Use only the existing shipping block: never add a promise where the theme omitted it.
 const wrapper=document.querySelector('#ProductForm .bb-shipping-countdown');
 if(!wrapper||wrapper.dataset.bbShipping)return;
 wrapper.dataset.bbShipping='true';
 const line=wrapper.querySelector('.bb-shipping-countdown__line');
 if(!line)return;line.replaceChildren();
 const message=document.createElement('span');line.append(message);
 let previous='';
 function tick(){
  const button=document.querySelector('#ProductForm .add-to-cart');
  const excluded=!config.productAvailable||!button||button.disabled||/pre.?order|sold out|unavailable/i.test(button.textContent);
  wrapper.style.display=excluded?'none':'inline-block';
  if(excluded)return;
  const s=state(Date.now(),config.closedDates);
  const h=String(Math.floor(s.remaining/3600)).padStart(2,'0'),m=String(Math.floor(s.remaining%3600/60)).padStart(2,'0'),sec=String(s.remaining%60).padStart(2,'0');
  const text=s.today?`Order within ${h} HRS : ${m} MINS : ${sec} SECS for dispatch today.`:`Orders placed now ship ${s.label}.`;
  if(text!==previous){message.textContent=text;previous=text;}
  wrapper.dataset.dispatchDate=s.date;wrapper.dataset.dispatchState=s.today?'today':'next-business-day';
 }
 tick();setInterval(tick,1000);document.addEventListener('visibilitychange',tick);window.addEventListener('pageshow',tick);
})(typeof window==='undefined'?{}:window);
